import React from 'react';
import './Contact.css'

const Contact = () => {
    return (
        <div className='container contact rounded shadow mx-auto px-5 py-1 my-5'>

            <section className="mb-4">
                <h2 className="h1-responsive fw-bold text-center my-4  title display-5" style={{ textDecoration: 'underline', color: "#EB6440" }}>Get in touch</h2>

                {/* <p className="text-center w-responsive mx-auto mb-5 text-white fw-bold">Do you have any questions? Please do not hesitate to contact me directly. I will come back to you within
                    a matter of hours to help you.</p> */}

                <div className="row">


                    <div className="col-md-9 mb-md-0 mb-5">
                        <form id="contact-form" name="contact-form" action="mail.php" method="POST">


                            <div className="row">


                                <div className="col-md-6">
                                    <div className="md-form mb-0">
                                        <input type="text" id="name" name="name" className="form-control" />
                                        <label for="name" className="">Your name</label>
                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className="md-form mb-0">
                                        <input type="text" id="email" name="email" className="form-control" />
                                        <label for="email" className="">Your email</label>
                                    </div>
                                </div>


                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="md-form mb-0">
                                        <input type="text" id="subject" name="subject" className="form-control" />
                                        <label for="subject" className="">Subject</label>
                                    </div>
                                </div>
                            </div>

                            <div className="row">


                                <div className="col-md-12">

                                    <div className="md-form">
                                        <textarea type="text" id="message" name="message" rows="2" className="form-control md-textarea"></textarea>
                                        <label for="message">Your message</label>
                                    </div>

                                </div>
                            </div>


                        </form>

                        <div className="text-center text-md-left">
                            <button className="btn btn-primary">Send</button>
                        </div>
                        <div className="status"></div>
                    </div>

                    <div className="col-md-3 text-center">
                        <ul className="list-unstyled mb-0">
                            <li><i className="fas fa-map-marker-alt fa-2x"></i>
                                <p>Chattogram, Bangladesh</p>
                            </li>

                            {/* <li><i className="fas fa-phone mt-4 fa-2x"></i>
                                <p>+ 01799999999</p>
                            </li> */}

                            <li><i className="fas fa-envelope mt-4 fa-2x"></i>
                                <p>jafrin3347@gmail.com</p>
                            </li>
                        </ul>
                    </div>


                </div>

            </section>
        </div>
    );
};

export default Contact;
